import axios from 'axios';
import urljoin from 'url-join';

const API_URL = '/api/v1/';

const getImageByPath = (path) => {
	return axios.get(urljoin(API_URL, path), {
		responseType: 'blob',
	});
};

export { getImageByPath };
